<template>
  <div role="dialog" aria-live="polite" :aria-label="$t('announcement.header')" class="cx-sticky -bg-danger announcement" 
    v-if="announcements.length > 0"
    :class="{
      '-collapsed': collapsed || !hasAnnouncementInQueue,
      '-showdetail': showDetail && !hasAnnouncementInQueue
    }"

    :style="(!collapsing && !hasAnnouncementInQueue) ? 'transition: none !important;' : ''"
  > 
    <div v-if="showDetail"
      ref="focus_container"
      class="cx-modal--full announcement-modal"
      v-trap-focus="{ escFunc: dismiss, live: true }">
      <div class="cx-modal__body">
        <button class="cx-btn cx-modal__close" 
          :aria-label="$t('action.close')"
          @click.prevent="dismiss">
          <i class="fas fa-fw fa-times"></i>
        </button>
        <div class="cx-card--notify">
          <announcement-board></announcement-board>
        </div>
      </div>
    </div>  
    <div class="cx-row--line cx-t02 announcement-content">
      <div class="cx-col cx-sticky__body announcement-bar"  
        @click="active"
      >
        <transition name="announcement-slide">
          <a :key="(announcement.issuedTime || 'empty') + summaryIdx"
            v-if="announcement && announcement.issuedTime"
            v-html="summary(announcement)"
          ></a>
        </transition>
      </div>
      <div class="cx-col cx-sticky__close">
        <button @click.prevent="handleNoticeIconClick" :aria-label="collapsed ? $t('action.open') : $t('action.close')">
          <i class="cx-sticky__close__normal fas fa-chevron-circle-up"></i>
          <i v-show="!showDetail"
            class="cx-sticky__close__collapsed fas fa-exclamation"
          ></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import announcementLartsHelper from '@/mixins/announcementLartsHelper';
import AnnouncementBoard from '@/components/AnnouncementBoard';
import autoFocus from '@/mixins/autoFocus';

export default {
  name: "announcement-bar",
  mixins: [announcementLartsHelper, autoFocus],
  lazyData({i18n, store, route}) {
    store.dispatch('announcement/FETCH', { locale: i18n.locale });
  }, 
  uit() {
    return [
      ['action', ['open', 'close']],
      ['announcement', ['header']]
    ]
  },
  data() {
    return {
      showDetail: false,
      collapsed: true,
      collapsing: false,
      lastScrollY: 0,
      summaryIdx: 0,
      timer: null,
      announcement: {},
      announcementUpdater: null
    }
  },
  components: {
    AnnouncementBoard
  },
  computed: {
    announcements: function() {
      return this.$store.getters['announcement/getAnnouncements'](this.$i18n.locale);
    },
    announcementQueue: function() {
      return this.announcements
        .filter(a => a.active && a.issuedTime > this.larts) || [];
    },
    hasAnnouncementInQueue: function() {
      this.collapsing = this.announcementQueue.length == 0;
      this.$nextTick(() => {
        setTimeout(() => { this.collapsing = false }, 350);
      })
      return this.announcementQueue.length > 0;
    },
    notes: function() {
      return {
        content: this.$store.getters['announcement/getInformations'](
          this.$i18n.locale
        ).map(r => r.content).join('')
      }
    }
  },
  watch: {
    announcementQueue: {
      immediate: true,
      deep: true,
      handler: function(val) {
        this.announcement = val[0] || {};
        
        if (val.length > 0) {
          this.triggerWindowResize();
          this.collapsed = false;
        }    
        if (val.length > 1) {
          this.restartLoop();
        } else {
          this.stopLoop();
        }
      },
    },
    '$route.path': function() {
      this.showDetail && this.dismiss();
    }
  },
  mounted() {
    // window.addEventListener('scroll', this.handleWindowScroll, window.passiveIfSupported);
    this.announcementUpdater = setInterval(() => {
      this.$store.dispatch('announcement/FETCH', { locale: this.$i18n.locale });
    }, 60000);
  },
  beforeDestroy() {
    // window.removeEventListener('scroll', this.handleWindowScroll, window.passiveIfSupported);
    this.stopLoop();
    this.announcementUpdater && clearInterval(this.announcementUpdater);
  },
  methods: {
    startLoop: function() {
      if (this.timer !== null) return;
      this.timer = this.createLoop();
    },
    stopLoop: function() {
      if (this.timer == null) return;
      clearInterval(this.timer);
      this.timer = null;
    },
    restartLoop: function() {
      this.summaryIdx = 0;
      this.stopLoop();
      this.startLoop();
    },
    createLoop: function() {
      return setInterval(() => {
        this.summaryIdx = ++this.summaryIdx % this.announcementQueue.length;
        this.announcement = this.announcementQueue[this.summaryIdx] || {};
      }, this.duration || 5000);
    },
    summary: function(announcement) {
      let summary =  this.parseShortDesc(announcement.content, false);

      return (announcement.isWarning 
        ? "<i class='fas fa-exclamation-triangle'></i> " 
        : "<i class='fas fa-info-circle'></i> "
      ) + summary;
    },
    triggerWindowResize: function() {
      if (typeof window != undefined) {
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
          console.log('[HH] active w-resize');
        }, 500);
      }
    },
    triggerCollapsed: function() {
      if (!this.collapsed) {
        this.updateLarts();
      }

      this.triggerWindowResize();
      this.collapsed = !this.collapsed;
      this.lastScrollY = window.scrollY;
    },
    active: function() {
      this.$store.dispatch('ui/FREEZE_BODY');
      this.showDetail = true;
      setTimeout(this._af_autoFocus, 0);
    },
    dismiss: function() {
      this.$store.dispatch('ui/DISMISS_FREEZE_BODY');
      this.showDetail = false;     
      this.triggerCollapsed();
    },
    handleWindowScroll: function() { 
      if (this.showDetail) return ;
      let y = window.scrollY;
      let diffY = y - this.lastScrollY;
      if (Math.abs(diffY) > 100) {
        this.lastScrollY = y;
        if (diffY > 0) {
          this.collapsed = true;
        } 
        // else {
        //   this.collapsed = false;
        // }
      }
    },
    handleNoticeIconClick: function() {
      if (this.hasAnnouncementInQueue) {
        this.triggerCollapsed();
      } else {
        this.active();
      }
    }
  }
}
</script>

<style lang="scss">
  .announcement {
    z-index: 10003 !important;
    &-content {
      justify-content: center;
    }
  }

  body.-freeze::after {
    z-index: 10002;
  }

  .announcement.-showdetail{
    & + *{
      margin-top: 0;
    }
    transition: none;
    transform: none;
    padding: 0px;
    .announcement-content{
      display: none;
    }
  }

  .announcement, .announcement + * {
    transition: all .3s ease-in-out;
  }

  .announcement:not(.-collapsed) + header {
    border-top: 0;
  }
  .announcement-modal{
    color: $color-black;
    .cx-modal__close {
      color: $color-white;
    }
  }
  .announcement-bar{
    width: 100% !important;
    height: $font-xs * $lineheight-xs;
    text-align: center;
    overflow: hidden;
    &:hover{
      cursor: pointer;
    }
  }
  .announcement-slide {
    &-enter-active, &-leave-active {
      text-overflow: ellipsis;
      overflow: hidden;
      transition: all .5s ease-in-out;
      display: block;
    }

    &-enter {
      transform: translateY(0);
      opacity: 0;
    }
    &-enter-to {
      transform: translateY(-$font-xs * $lineheight-xs);
    }
    
    &-leave {
      transform: translateY(0);
      opacity: 1;
    }

    &-leave-to {
      transform: translateY(-$font-xs * $lineheight-xs);
      opacity: 0;
    }
  }

</style>
